import {Component, HostBinding, Inject, OnInit, ViewChild} from '@angular/core';
import {CompetitorsPricesDataService} from '../services/prices-comp.data.service';
import {CompetitorsPricesQueryList} from '../services/models';
import {XlsxResponseModel} from 'app/core';
import {GeneralService, SnackbarService} from 'app/core';
import {finalize} from 'rxjs/operators';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {LocalTableComponent} from '../../../components/new-table/local-table/local-table.component';

export interface DialogData {
    delete: () => void;
}


@Component({
    selector: 'app-prices-comp-browser',
    templateUrl: './prices-comp-browser.component.html',
    styleUrls: ['./prices-comp-browser.component.scss']
})
export class CompetitorsPricesBrowserComponent implements OnInit {

    @HostBinding('class') classes = 'flex flex-grow';

    @ViewChild('localTable') localTable: LocalTableComponent;

    columnsData: Array<any>;
    tableId: string;
    isLoadingTable = false;
    data: CompetitorsPricesQueryList[] = [];

    importLoading = false;
    isDeleting = false;

    isDeleteButtonDisabled = true;

    private selected: CompetitorsPricesQueryList[] = [];

    constructor(
        public dataService: CompetitorsPricesDataService,
        public dialog: MatDialog,
        private generalService: GeneralService,
        private snackbar: SnackbarService
    ) {

    }

    ngOnInit(): void {
        const tableInfo = CompetitorsPricesQueryList.tableInfo();
        this.columnsData = tableInfo.columns;
        this.tableId = tableInfo.tableId + '_CompetitorsPricesBrowserComponent';
        this.loadCompPrices();
    }

    selectedRows(rows: CompetitorsPricesQueryList[]) {
        this.selected = rows;
        this.selected.length === 0 ? this.isDeleteButtonDisabled = true : this.isDeleteButtonDisabled = false;
    }

    export(contentType: string) {
        this.importLoading = true;

        if (contentType === 'csv') {
            this.dataService.getCsv()
                .subscribe(
                    response => {
                        const blob = new Blob(['\ufeff', response.body], { type: contentType });
                        const filename = this.generalService
                            .getFilenameFromHeader(response.headers.get('content-disposition'));
                        saveAs(blob, `${filename}.csv`);
                    },
                    error => {
                        this.importLoading = false;
                        if (error.status !== 403) { this.snackbar.info('Wystąpił błąd podczas zapisywania plik.'); }
                    },
                    () => this.importLoading = false
                );
        }
        if (contentType === 'xlsx') {
            this.dataService.getXlsx()
                .subscribe(
                    (blogResp: XlsxResponseModel) => {
                        this.loadExcel(blogResp);
                    },
                    error => {
                        this.importLoading = false;
                        if (error.status !== 403) { this.snackbar.info('Wystąpił błąd podczas zapisywania plik.'); }
                    },
                    () => this.importLoading = false
                );
        }
    }

    openDialog(): void {
        this.dialog.open(DialogDeletePrices, {
            data: {
                delete: this.deletePrices
            }
        });
    }

    deletePrices = (): void => {
        const formData = this.formDeleteResponse();
        this.isDeleting = true;
        this.dataService.delete(formData)
            .pipe(finalize(() => this.isDeleting = false))
            .subscribe(
                response => this.removeDeletedPrices()
            );
    }

    private formDeleteResponse(): any {
        return {
            PricesIds: this.selected.map(sel => sel.Id)
        };
    }

    private removeDeletedPrices() {
        const selectedIds: number[] = this.selected.map(sel => sel.Id);
        this.data = this.data.filter(price => !selectedIds.includes(price.Id));
        this.selected = [];
        this.localTable.selected = [];
    }

    private loadExcel(resp: XlsxResponseModel) {
        const filename = this.generalService.getFilenameFromHeader(resp.titleHeader);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(resp.blob);
        link.download = `${filename}.xlsx`;
        link.click();
    }

    private loadCompPrices(): void {
        this.isLoadingTable = true;
        this.dataService.fetchData(null, null, 'ImportDate desc, CompStoreName asc, RegistrationName asc, SkuName asc', null, null)
            .subscribe(
                res => this.data = res.items,
                logErr => {
                    console.log(logErr);
                    this.isLoadingTable = false;
                },
                () => this.isLoadingTable = false
            );
    }

}

@Component({
    selector: 'dialog-delete-prices',
    templateUrl: 'dialog-delete-prices.html',
})

export class DialogDeletePrices {
    constructor(
        public dialogRef: MatDialogRef<DialogDeletePrices>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        public snackBar: SnackbarService
    ) { }

    confirmDelete(): void {
        this.data.delete();
        this.dialogRef.close();
    }
}
